import { render } from "./VideoCroppingModal.vue?vue&type=template&id=6c650dba&scoped=true"
import script from "./VideoCroppingModal.vue?vue&type=script&lang=js"
export * from "./VideoCroppingModal.vue?vue&type=script&lang=js"

import "./VideoCroppingModal.vue?vue&type=style&index=0&id=6c650dba&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c650dba"]])

export default __exports__